import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LinkedIn } from 'icons/linkedin.svg';
import { ReactComponent as Google } from 'icons/google.svg';
import { ReactComponent as Facebook } from 'icons/facebook.svg';
import env from 'env';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import mixpanelService from 'services/mixpanelService';
import { SignupInitiatedProps, SignupSource } from 'models/MixpanelEvents';
import classNames from 'classnames';

import './AlternateLogins.styles.scss';
import './AlternateLogins.styles.responsive.scss';

type AlternateLoginsProps = {
  className?: string;
  signupSource?: SignupSource;
};

const AlternateLogins: React.FC<AlternateLoginsProps> = ({
  className,
  signupSource,
}) => {
  const { t } = useTranslation();

  const classes = classNames('alternate-logins', className);

  const getMixpanelProps = useGetMixpanelProps();

  const onSocialLogin = useCallback(() => {
    if (!signupSource) return;

    mixpanelService.signupInitiated(
      getMixpanelProps({
        socialSignup: true,
        signupSource,
      }) as SignupInitiatedProps,
    );
  }, [signupSource, getMixpanelProps]);

  return (
    <div className={classes}>
      <p className="or">{t('orSignIn')}</p>

      <article className="alt-login">
        <a
          href={`${env.SERVER_ENDPOINT}/api/auth/linkedin`}
          onClick={onSocialLogin}
        >
          <LinkedIn />
          LinkedIn
        </a>
        <a
          href={`${env.SERVER_ENDPOINT}/api/auth/facebook`}
          onClick={onSocialLogin}
        >
          <Facebook />
          Facebook
        </a>
        <a
          href={`${env.SERVER_ENDPOINT}/api/auth/google`}
          onClick={onSocialLogin}
        >
          <Google />
          Google
        </a>
      </article>
    </div>
  );
};

export default AlternateLogins;
